module.exports = __webpack_public_path__ + "img/icon_topbar_01.b5ef6897.png";